/**
 * Разбор чисел автопополнения ДО нажатия «сохранить».
 *
 * ТА ЖЕ ПРОВЕРКА СТОИТ НА СЕРВЕРЕ, и она главная: экран можно обойти,
 * сервер — нет. Здесь она нужна ради другого. Отказ, прилетевший после
 * нажатия, человек читает как поломку; предупреждение, показанное
 * до нажатия, — как заботу. И только второе даёт ему шанс заметить,
 * что он перепутал порог с суммой.
 *
 * ЭТО ЕДИНСТВЕННОЕ МЕСТО КАБИНЕТА, ГДЕ СЕРВИС ТРАТИТ ДЕНЬГИ САМ,
 * и предупреждения тут стоят дороже обычного.
 */

/**
 * Меньше этого Wildberries пополнить не даёт.
 *
 * ЗДЕСЬ СТОЯЛА СОТНЯ — НЕВЕРНАЯ ВДЕСЯТЕРО. Настоящее число измерено
 * живьём 15.08.2026 пробой с нулевой суммой: `{"error":"Invalid Params:
 * minimum deposit amount is 1000"}`. На сервере его тогда же исправили,
 * а эта копия осталась прежней — и разошлась молча.
 *
 * ЧЕМ ЭТО ГРОЗИЛО. Экран принимал «пополнять на 500» как законное:
 * предупреждения нет, кнопка «сохранить» живая. Отказ приходил
 * с сервера — после нажатия, то есть в виде поломки, а не заботы.
 * А сохранись такая настройка, снаружи это выглядит ещё хуже:
 * «автопополнение включено и почему-то не работает», при пустом счёте
 * и вставших показах.
 *
 * ПОЭТОМУ РЯДОМ СТОИТ ПРОВЕРКА, ЧИТАЮЩАЯ ИСХОДНИК СЕРВЕРА. Общего
 * модуля у сервиса и кабинета нет, значит копия неизбежна; тишина при
 * её расхождении — нет.
 */
export const MIN_AMOUNT = 1000;

/**
 * Разбор суммы для пополнения РУКОЙ — кнопка «+» в столбце бюджета.
 *
 * ЗДЕСЬ НЕТ НИ ПОРОГА, НИ ПОТОЛКА, И ЭТО НЕ УПУЩЕНИЕ. Порог отвечает
 * на вопрос «когда пополнять сам», потолок ограничивает то, что сервис
 * тратит БЕЗ нажатия. У нажатия нет ни того, ни другого: решение принял
 * человек, здесь и сейчас, и запрещать ему положить денег на свою
 * кампанию значит принять предохранитель за правило.
 *
 * Остаются границы Wildberries: тысяча снизу, сто тысяч сверху —
 * последняя ловит лишний ноль.
 */
export const MAX_AMOUNT = 100_000;

export function warnManual(amount: string): Warning | null {
  const v = parseMoney(amount);
  if (v === null) {
    return { fatal: true, text: 'Введите сумму — целое число рублей больше нуля.' };
  }
  if (v < MIN_AMOUNT) {
    return { fatal: true, text: `Меньше ${MIN_AMOUNT} ₽ Wildberries пополнить не даёт.` };
  }
  if (v > MAX_AMOUNT) {
    return { fatal: true, text: `Больше ${MAX_AMOUNT} ₽ за раз — проверьте число, нет ли лишнего нуля.` };
  }
  // НЕ ОШИБКА, НО СТОИТ СКАЗАТЬ. Крупная сумма по нажатию — самая
  // дорогая опечатка в кабинете: деньги уходят сразу и обратно
  // не возвращаются.
  if (v >= 10_000) {
    return { fatal: false, text: 'Сумма немаленькая — проверьте, не лишний ли ноль.' };
  }
  return null;
}

export interface Draft {
  below: string;
  amount: string;
  dailyCap: string;
}

export interface Warning {
  /** `true` — сохранять нельзя, сервер откажет. */
  fatal: boolean;
  text: string;
}

export function parseMoney(v: string): number | null {
  const t = v.trim().replace(',', '.').replace(/\s/g, '');
  if (t === '') return null;
  const n = Number(t);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * Что не так с настройкой. `null` — всё в порядке.
 *
 * ПОРЯДОК ПРОВЕРОК ОТ ХУДШЕГО К МЕЛКОМУ: цикл дороже всего, о нём
 * и говорим первым.
 */
export function warnTopup(d: Draft, on: boolean): Warning | null {
  if (!on) return null;

  const below = parseMoney(d.below);
  const amount = parseMoney(d.amount);
  const cap = parseMoney(d.dailyCap);

  if (below === null || amount === null) {
    return {
      fatal: true,
      text: 'Нужны оба числа: при каком остатке пополнять и на сколько. Одно без другого не работает.',
    };
  }

  if (amount < MIN_AMOUNT) {
    return { fatal: true, text: `Меньше ${MIN_AMOUNT} ₽ Wildberries пополнить не даёт.` };
  }

  // САМОЕ ДОРОГОЕ. Пополнение меньше порога не выводит счёт из-под порога:
  // следующая проверка увидит остаток снова ниже и пополнит опять.
  if (amount < below) {
    return {
      fatal: true,
      text:
        `Пополнение ${amount} ₽ меньше порога ${below} ₽: после него остаток снова окажется ` +
        'ниже порога, и сервис пополнит ещё раз, и ещё. Сумма должна быть не меньше порога.',
    };
  }

  /**
   * ═══════════════════════════════════════════════════════════════════
   * ПОТОЛОК ЗА СУТКИ БОЛЬШЕ НЕ НАСТРАИВАЕТСЯ ЭТОЙ ФОРМОЙ (01.09.2026).
   *
   * Владелец: «в настройках автопополнения стоит суточный лимит, его
   * быть тут не должно, т.к. есть отдельная вкладка с лимитами».
   * Поле убрано; у кампаний, где потолок задан раньше, он продолжает
   * работать, и снимается кнопкой «Снять потолок».
   *
   * ЗДЕСЬ БЫЛО ДВЕ ПОДСКАЗКИ, И ОБЕ ПРИШЛОСЬ ПЕРЕПИСАТЬ.
   *
   * Первая — «потолок меньше пополнения, не пройдёт ни одно» —
   * осталась запретом (иначе человек сохранил бы настройку, которая
   * не сработает ни разу), но теперь называет ВЫХОД: поля больше нет,
   * и без указания на кнопку это был бы тупик.
   *
   * Вторая — «потолок не задан, верхней границы у траты нет» — убрана
   * совсем. Она советовала заполнить поле, которого больше нет:
   * подсказка, зовущая туда, куда не пройти, хуже молчания.
   * ═══════════════════════════════════════════════════════════════════
   */
  if (cap !== null && cap < amount) {
    return {
      fatal: true,
      text:
        `Потолок за сутки ${cap} ₽ меньше одного пополнения ${amount} ₽ — не пройдёт ни одно. ` +
        'Снимите потолок кнопкой ниже или уменьшите сумму пополнения.',
    };
  }

  return null;
}

/** Сколько ещё можно потратить сегодня. */
export function capLeft(cap: number | null, spentToday: number): number | null {
  if (cap === null) return null;
  return Math.max(0, cap - spentToday);
}
